import RoutesMap from "route_control/RouteControl"
import { PurchaseList } from "pages/purchase"
import { SessionList } from "pages/sessions"
import { TicketList, AddTicket, TicketDetails } from "pages/ticket"
import { Recharge, PurchaseHistoryList, PaymentRedirect, PaymentStatus } from "pages/recharge"
import { ModemPassword, SelfCarePassword } from "pages/password"

const CustomerRoute = () => {
    return [
        {
            path: RoutesMap.PURCHASE_LIST.path,
            element: <PurchaseList />
        },
        {
            path: RoutesMap.SESSION_LIST.path,
            element: <SessionList />
        },
        {
            path: RoutesMap.TICKET_LIST.path,
            element: <TicketList />
        },
        {
            path: RoutesMap.ADD_TICKET.path,
            element: <AddTicket />
        },
        {
            path: `${RoutesMap.TICKET_DETAILS.path}/:id`,
            element: <TicketDetails />
        },
        {
            path: RoutesMap.RECHARGE.path,
            element: <Recharge />
        },
        {
            path: RoutesMap.PURCHASE_HISTORY.path,
            element: <PurchaseHistoryList />
        },
        {
            path: `${RoutesMap.PAYMENT_REDIRECT.path}/:id`,
            element: <PaymentRedirect />
        },
        {
            path: RoutesMap.PAYMENT_STATUS.path,
            element: <PaymentStatus />
        },
        {
            path: RoutesMap.MODEM_PASSWORD.path,
            element: <ModemPassword />
        },
        {
            path: RoutesMap.SELFCARE_PASSWORD.path,
            element: <SelfCarePassword />
        },
    ]
}

export default CustomerRoute;
